import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {Photographer} from '../../entities/photographer/photographer.entity';
import {environment} from '../../../../environments/environment';
import {Booking} from '../../../core/entities/booking/booking.entity';
import {Service} from '../../../core/entities/service/service.entity';

@Injectable({
  providedIn: 'root'
})
export class ServiceService
{
  public constructor(
    private readonly http: HttpClient,
  ) {
  }

  public getService(id: number): Observable<Service> {
    return this.http.get<Service>(`${environment.apiUrl}/api/v1/marketplace/service/${id}`);
  }
}
